import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

function ProtectedRoute({ children, requireAuth = true, requireAdmin = false }) {
  const location = useLocation()
  const { isAuthenticated, isAdmin, loading } = useAuth()

  // Show loading spinner while checking auth state
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    )
  }

  // Check authentication requirement
  if (requireAuth && !isAuthenticated) {
    // Redirect to login page with return url
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Check admin requirement
  if (requireAdmin && !isAdmin) {
    return (
      <div className="access-denied">
        <div className="access-denied-content">
          <h2>Access Denied</h2>
          <p>You don't have permission to access this area.</p>
          <p>Please contact an administrator if you believe this is an error.</p>
        </div>
      </div>
    )
  }

  // For admin routes, automatically require admin access
  if (location.pathname.startsWith('/admin') && !isAdmin) {
    return (
      <div className="access-denied">
        <div className="access-denied-content">
          <h2>Access Denied</h2>
          <p>You don't have permission to access this area.</p>
          <p>Please contact an administrator if you believe this is an error.</p>
        </div>
      </div>
    )
  }

  return children
}

export default ProtectedRoute